import React, { useRef } from 'react'
import { Upload } from 'lucide-react'
import { Spinner } from '@/components/admin/atoms/feedback/Spinner'
import styles from './UploadButton.module.scss'

interface UploadButtonProps {
  onUpload: (files: FileList | null) => void
  accept?: string
  multiple?: boolean
  loading?: boolean
  children?: React.ReactNode
  className?: never
}

export const UploadButton: React.FC<UploadButtonProps> = ({
  onUpload, accept = 'image/*,application/pdf', multiple = true, loading = false, children,
}) => {
  const inputRef = useRef<HTMLInputElement>(null)

  return (
    <label className={styles.label}>
      <input
        ref={inputRef}
        type="file"
        multiple={multiple}
        accept={accept}
        onChange={(e) => {
          onUpload(e.target.files)
          if (inputRef.current) inputRef.current.value = ''
        }}
        className={styles.hidden}
      />
      <div className={styles.button}>
        {loading ? <Spinner size="sm" /> : <Upload style={{ width: 16, height: 16 }} />}
        {children ?? 'Upload'}
      </div>
    </label>
  )
}
